"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _dvaNoRouter = require("dva-no-router");

var _echarts = _interopRequireDefault(require("echarts"));

var _dec, _class, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var colorData = ['#1785EC', '#FFAB71', '#F2637B', '#36CBCB', '#4DCB73', '#975FE4', '#FFA8CC', '#7384A1', '#FAD337', '#008589'];
var Pie = (_dec = (0, _dvaNoRouter.connect)(function (_ref) {
  var global = _ref.global,
      rest = _objectWithoutProperties(_ref, ["global"]);

  return _objectSpread({}, global, {
    rest: rest
  });
}), _dec(_class = (_temp =
/*#__PURE__*/
function (_Component) {
  _inherits(Pie, _Component);

  function Pie() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Pie);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Pie)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEchartsProps", function (props) {
      var echartsId = props.echartsId,
          title = props.title,
          legend = props.legend,
          dataSource = props.dataSource,
          typeProps = props.typeProps,
          label = props.label,
          selfProps = _objectWithoutProperties(props, ["echartsId", "title", "legend", "dataSource", "typeProps", "label"]);

      _this.myChart = _echarts.default.init(document.getElementById(echartsId));
      var tempDataSource = [];
      var defaultLabel = {
        show: true,
        color: 'white',
        position: 'inside',
        formatter: '{d}%'
      };
      dataSource.forEach(function (item, index) {
        if (index < 10) {
          tempDataSource.push(_objectSpread({}, item));
        }
      }); // 指定图表的配置项和数据

      var option = _objectSpread({
        title: _objectSpread({
          show: false
        }, title),
        tooltip: {
          formatter: function formatter(v) {
            var percent = v.percent,
                name = v.name;
            var text = "".concat(percent, "% ").concat(name);
            return text;
          },
          extraCssText: 'width:80px; white-space:pre-wrap;'
        },
        legend: _objectSpread({
          right: '2%',
          top: 'middle',
          icon: 'circle',
          orient: 'vertical',
          selectedMode: true,
          tooltip: {
            show: true
          },
          formatter: function formatter(name) {
            return name.length > 8 ? "".concat(name.substr(0, 8), "...") : name;
          }
        }, legend),
        series: [_objectSpread({
          type: 'pie',
          top: 'middle',
          data: tempDataSource,
          avoidLabelOverlap: true,
          color: colorData,
          label: _objectSpread({}, defaultLabel, label),
          left: '-5%'
        }, typeProps)]
      }, selfProps); // 使用刚指定的配置项和数据显示图表。


      _this.myChart.setOption(option);
    });

    return _this;
  }

  _createClass(Pie, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleEchartsProps(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.handleEchartsProps(nextProps);
    } // 处理图表属性

  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null);
    }
  }]);

  return Pie;
}(_react.Component), _temp)) || _class);
var _default = Pie;
exports.default = _default;